import { AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { StyledAccordion } from './styles';
import { FiArrowDown, FiCheckCircle, FiCircle } from 'react-icons/fi';
import { Theme } from 'app/shared/utils';
import { useState, useEffect } from 'react';

const EstrategiaViewComponent = ({
  categorias = [],
  selectedPergunta,
  onClickPergunta,
  respostas,
}) => {
  const secoes = {};
  categorias.forEach((categoria) => {
    const secao = categoria.secao_categoria || { id: 'sem_secao', nome: 'Sem Seção', cor: '#ddd' };
    if (!secoes[secao.id]) {
      secoes[secao.id] = {
        ...secao,
        categorias: [],
      };
    }
    secoes[secao.id].categorias.push(categoria);
  });

  const [secaoAberta, setSecaoAberta] = useState({});
  const [categoriaAberta, setCategoriaAberta] = useState({});

  useEffect(() => {
    if (!selectedPergunta) return;

    const categoriaDaPergunta = categorias.find(categoria =>
      categoria.perguntas.some(pergunta => pergunta.id === selectedPergunta.id)
    );

    if (!categoriaDaPergunta) return;

    const secaoId = categoriaDaPergunta.secao_categoria?.id || 'sem_secao';
    const categoriaId = categoriaDaPergunta.id;

    setSecaoAberta({ [secaoId]: true });
    setCategoriaAberta({ [categoriaId]: true });

  }, [selectedPergunta, categorias]);

  const toggleSecao = (id) => {
    setSecaoAberta(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleCategoria = (id) => {
    setCategoriaAberta(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <>
      <Typography variant="caption">* Questões obrigatórias</Typography>

      {Object.values(secoes).map((secao) => (
        <StyledAccordion
          key={`secao-${secao.id}`}
          expanded={!!secaoAberta[secao.id]}
          onChange={() => toggleSecao(secao.id)}
          elevation={0}
          disableGutters
        >
          <AccordionSummary
            sx={{ background: "#1976d2", color: "white" }}
            expandIcon={<FiArrowDown color='white'/>}
          >
            <Typography fontSize="16px" fontWeight="bold">
              {secao.nome}
            </Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: 0 }}>
            {secao.categorias.map((categoria) => (
              <StyledAccordion
                key={`categoria-${categoria.id}`}
                expanded={!!categoriaAberta[categoria.id]}
                onChange={() => toggleCategoria(categoria.id)}
                elevation={0}
                disableGutters
                sx={{ boxShadow: 'none' }}
              >
                <AccordionSummary
                  sx={{ backgroundColor: categoria.cor }}
                  expandIcon={<FiArrowDown />}
                >
                  <Typography
                    fontSize="13px"
                    fontWeight="bold"
                  >
                    {categoria.nome}
                  </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{ padding: '0px' }}>
                  {[...categoria.perguntas]
                    .sort((a, b) => {
                      const getPassoNumero = (titulo) => {
                        const match = titulo.match(/Passo\s*(\d+)/i);
                        return match ? parseInt(match[1], 10) : 0;
                      };
                      return getPassoNumero(a.titulo) - getPassoNumero(b.titulo);
                    })
                    .map((pergunta) => {
                      const hasResposta = !!respostas?.[pergunta.id]?.answered;
                      const obrigatorio = pergunta.obrigatorio === '1';
                      return (
                        <Box
                          onClick={() => onClickPergunta(pergunta.id)}
                          sx={{ cursor: 'pointer' }}
                          key={`pergunta-${pergunta.id}`}
                          bgcolor={selectedPergunta.id === pergunta.id ? 'whitesmoke' : 'white'}
                          display="flex"
                          width="100%"
                          p="5px 0px"
                          alignItems="center"
                          borderTop={`1px solid ${Theme.colors.gray.ligth}`}
                        >
                          <div style={{ marginLeft: 10 }}>
                            {hasResposta ? <FiCheckCircle /> : <FiCircle ml="10px" />}
                          </div>
                          <Box ml="10px" width="100%" display="flex" flexDirection="column">
                            <Typography fontSize="14px">
                              {`${obrigatorio ? '* ' : ''}${pergunta.titulo}`}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })}
                </AccordionDetails>
              </StyledAccordion>
            ))}
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </>
  );
};

export default EstrategiaViewComponent;

